/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

// Browser-level Kiosk lock preference, matching wallpaper.ts's storage/event
// pattern. When locked, KioskView hides its Edit/Add Widget controls so a
// wall-mounted iPad running Kiosk mode can't be rearranged by a passerby.

const KIOSK_LOCK_KEY = "nyrvex-kiosk-lock";

export const getKioskLock = (): boolean => {
  return localStorage.getItem(KIOSK_LOCK_KEY) === "true";
};

export const setKioskLock = (locked: boolean): void => {
  if (locked) {
    localStorage.setItem(KIOSK_LOCK_KEY, "true");
  } else {
    localStorage.removeItem(KIOSK_LOCK_KEY);
  }
  // The native `storage` event only fires in *other* tabs -- dispatch our
  // own so the current tab's KioskView picks up the change immediately too.
  window.dispatchEvent(new CustomEvent("kiosklockchange"));
};
